import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { Plus, Edit2 } from 'lucide-react';
import moment from 'moment';
import UpdateBankAccountModal from './UpdateBankAccountModal';
import { Section, Facts, Fact, UpcomingBadge, HistoryToggle, HistoryTable, SectionEmpty, formatDate, formatPeriod } from './EmployeeDetailParts';

const BankAccountCard = ({ employeeId, companyId, bankAccount, history, currentContract, onUpdate }) => {
  const [showHistory, setShowHistory] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [modalMode, setModalMode] = useState('create'); // 'create' or 'edit'

  const handleCreateClick = () => {
    setModalMode('create');
    setShowUpdateModal(true);
  };

  const handleEditClick = () => {
    setModalMode('edit');
    setShowUpdateModal(true);
  };

  const formatDate = (date) => {
    return moment(date).format('DD MMM YYYY');
  };

  const handleUpdateSuccess = () => {
    setShowUpdateModal(false);
    if (onUpdate) onUpdate();
  };

  return (
    <>
      <Section
        id="bank-account-heading"
        title="Bankkonto"
        badge={<UpcomingBadge show={Boolean(bankAccount?._isFuture)} />}
        meta={bankAccount
          ? (bankAccount.valid_from ? `${bankAccount._isFuture ? 'Börjar' : 'Gäller från'} ${formatDate(bankAccount.valid_from)}` : null)
          : 'Inget bankkonto registrerat'}
        actions={bankAccount && (
          <>
            <button type="button" className="ll-btn ll-btn--ghost ll-btn--sm" onClick={handleEditClick} aria-label="Redigera bankkonto">
              <Edit2 />
              Ändra
            </button>
            <button type="button" className="ll-btn ll-btn--secondary ll-btn--sm" onClick={handleCreateClick} aria-label="Skapa nytt bankkonto för anställd">
              <Plus />
              Nytt konto
            </button>
          </>
        )}
      >
        {bankAccount ? (
          <>
            <Facts tight>
              <Fact label="Clearingnummer">{bankAccount.clearing_no}</Fact>
              <Fact label="Kontonummer">{bankAccount.account_no}</Fact>
              {bankAccount.iban && <Fact label="IBAN" wide>{bankAccount.iban}</Fact>}
              {bankAccount.bic && <Fact label="BIC/SWIFT">{bankAccount.bic}</Fact>}
            </Facts>

            <HistoryToggle
              open={showHistory}
              onToggle={() => setShowHistory(!showHistory)}
              count={history && history.length > 1 ? history.length - 1 : 0}
              noun="kontohistorik"
            />
            <Collapse in={showHistory}>
              <div>
                {history && history.length > 1 && (
                  <HistoryTable
                    columns={['Period', 'Konto']}
                    rows={history}
                    rowKey="bank_id"
                    render={(a) => [formatPeriod(a), [a.clearing_no, a.account_no].filter(Boolean).join('-') || '–']}
                  />
                )}
              </div>
            </Collapse>
          </>
        ) : (
          <SectionEmpty
            action={
              <button type="button" className="ll-btn ll-btn--secondary ll-btn--sm" onClick={handleCreateClick} aria-label="Lägg till bankkonto för anställd">
                <Plus />
                Lägg till bankkonto
              </button>
            }
          >
            Behövs för att betala ut lön.
          </SectionEmpty>
        )}
      </Section>

      <UpdateBankAccountModal
        show={showUpdateModal}
        handleClose={() => setShowUpdateModal(false)}
        employeeId={employeeId}
        companyId={companyId}
        currentBankAccount={modalMode === 'edit' ? bankAccount : null}
        currentContract={currentContract}
        mode={modalMode}
        onSuccess={handleUpdateSuccess}
      />
    </>
  );
};

export default BankAccountCard;
